"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillDataRequest = void 0;
var BillDataRequest = /** @class */ (function () {
    function BillDataRequest() {
    }
    return BillDataRequest;
}());
exports.BillDataRequest = BillDataRequest;
;
//# sourceMappingURL=billData.request.js.map